import colors from '@sportninja/common/constants/appColors'
import React from 'react'

interface SingleDivisionIconProps {
  color?: string
  size?: number
}

/**
 * Single Division icon for competition setup wizard
 */
const SingleDivisionIcon: React.FC<SingleDivisionIconProps> = ({
  color = colors.PRIMARY,
  size = 40,
}) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={size}
      height={size}
      viewBox='0 0 40 40'
      fill='none'
    >
      <path
        d='M32 8.33333V31.6667H8.66671V8.33333H32ZM32 5H8.66671C6.83337 5 5.33337 6.5 5.33337 8.33333V31.6667C5.33337 33.5 6.83337 35 8.66671 35H32C33.8334 35 35.3334 33.5 35.3334 31.6667V8.33333C35.3334 6.5 33.8334 5 32 5Z'
        fill={color}
      />
    </svg>
  )
}

export default SingleDivisionIcon
